import SpecificErrorPage from "./SpecificErrorPage";

/**
 * Displays an error dialog for the 404 Not Found error.
 */
export default function NotFound() {
	return <SpecificErrorPage statusCode={"404"}/>
}
